<script lang="ts">
	import fnum from 'shared/number'
	import type { SomeTypeOfNumber } from 'shared/number'
	import type { FinancialNumber } from 'financial-number'

	export let promo_discount_rate: SomeTypeOfNumber

	const trim_excessive_precision = (number: FinancialNumber) => number.changePrecision(0).equal(number)
		? number.changePrecision(0)
		: number.changePrecision(1).equal(number)
			? number.changePrecision(1)
			: number.changePrecision(2)
</script>

<div>
	{trim_excessive_precision(fnum(promo_discount_rate.toString()).times(`100`))}% off
</div>

<style>
	div {
		--letter-spacing: calc(var(--font-size) / 8);
		--padding: calc(var(--font-size) / 2);
		background-color: var(--flaregun-red);
		color: var(--contrast-text);
		font-size: var(--font-size);
		font-weight: 500;
		letter-spacing: var(--letter-spacing);
		line-height: 1;
		padding: var(--padding) calc(var(--padding) - var(--letter-spacing)) var(--padding) var(--padding);
		text-transform: uppercase;
	}

	@media (max-width: 600px) {
		div {
			--font-size: var(--mobile-font-size);
		}
	}
</style>
